/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/



// Import React Systems
import { useState } from 'react'

// Imports MUI Components
import {
  Box,
  Grid,
  Stack,
  Card,
  CardMedia,
  CardContent,
  Rating
} from "@mui/material"

import Text from "../../../atoms/text/Text"
import AccordionComp from "../../../atoms/accordion/AccordionComp"

import heart from "../../../../../assets/heart.png"
import shield from "../../../../../assets/shield.png"
import ribbon from "../../../../../assets/ribbon.png"
import clock from "../../../../../assets/clock_hollow.png"
import Icon from '../../../atoms/icon/Icon'
import julianne from "../../../../../assets/profile_julianne.png"
import jacky from "../../../../../assets/profile_jacky.png"
import clinic from "../../../../../assets/images/clinic2.jpg"

// import "./styles.css"

const Section = ({
  section,
  title,
  card
}) => {

  const gridStylesContainer = {
    backgroundColor: "transparent",
    justifyContent: "center",
    padding: {
      xs: "80px 20px 80px 20px", 
      sm: "80px 30px 80px 30px", 
      md: "80px 110px 80px 110px", 
      lg: "80px 110px 80px 110px", 
      xl: "80px 110px 80px 110px" 
    },
    width: "100%",
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
    },
  }

  const boxStylesWrapper = {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
  }
  
  const boxStylesContainer = {
    height: "100%",
    justifyContent: "center",
    textAlign: 
      section === "team" ? "center": 
      null,
    borderRadius: "20px",
    backgroundColor: "transparent",
  }

  const cardStyleContainer = {
    padding: 
      section === "team" ? "20px 10px":
      "10px",
    borderRadius: "20px",
    backgroundColor: "#FEFEFE",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    textAlign: section === "team" ? null : "justify"
  }

  const cardStylesStory = {
    borderRadius: "20px",
    backgroundColor: "transparent",
  }

  const stackStylesRating = {
    padding: "10px 0 0 10px"
  }

  return (
    <>
      {/*Grids */}
      <Grid
        container
        rowSpacing={4}
        columnSpacing={6}
        sx={gridStylesContainer}
      >

        <Box
          sx={boxStylesWrapper}
        >

          <Text
            text={title}
            variant="h2"/>
                     
        </Box>

        {section === "story" ? (
          <>
            {/* Title Wrapper */}
            <Grid 
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                lg: 6,
                xl: 6
              }}
              item
            >

              <Box
                sx={boxStylesWrapper}
              >
  
                <Card
                  elevation={0}
                  sx={cardStylesStory}
                >
                        
                  <CardContent>

                    <Stack
                      direction="column"
                      spacing={3}
                      textAlign="justify"
                    >

                    <Text
                      text="At VSDiamond Dental Clinic, we believe that every smile is a reflection of health, confidence, and joy. Our journey began with a simple vision: to provide exceptional dental care that blends advanced technology with genuine compassion. From preventive treatments to cosmetic enhancements, we are dedicated to helping patients achieve smiles that not only look beautiful but also feel strong and healthy."
                      variant="body1"/>

                    <Text
                      text="What sets us apart is our commitment to building lasting relationships with our patients. We take the time to listen, understand, and tailor our services to each individual’s needs. By fostering a welcoming environment and prioritizing comfort, we ensure that every visit is a positive experience—one that inspires trust and keeps our patients smiling for years to come."
                      variant="body1"/>

                    </Stack>

                  </CardContent>
                                
                </Card>
              </Box>
            </Grid>

            {/* Image Wrapper */}
            <Grid 
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                lg: 6,
                xl: 6
              }}
              item
            >

              <Box
                sx={boxStylesWrapper}
              >
  
                <Card
                  elevation={0}
                  sx={{
                    ...cardStylesStory,
                    position: "relative",
                    overflow: "hidden",
                    minHeight: 350,
                  }}
                >
                  <CardMedia
                    component="img"
                    image={clinic}
                    alt="Clinic"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 0,
                    }}
                  />

                </Card>    
              </Box>
            </Grid>
          </>
        ) : (null)}

        {/* Content */}
        {[
          { 
            img: 
              section === "team" ? julianne:
              heart,
            title: 
              section === "team" ? "Dr. Julianne Valle-So":
              "Patient-Centered", 
            caption: 
              section === "team" ? "Dedicated to creating beautiful, lasting smiles, Dr. Julianne brings years of expertise in cosmetic and restorative dentistry. Her gentle approach and attention to detail make every patient feel comfortable and valued. ":
              section === "story" ? "We treat every patient like family. From your first visit to your follow-up care, our team ensures a welcoming, stress-free experience tailored to your needs. Your comfort and satisfaction are at the heart of everything we do." :
              "Aesthetic clinic. Accomodating staff. The dentist provide excellent service. Overall, 100% recommended",
            author: 
              section === "testimonials" ? "Marie Gold" :
              null
          },
          { 
            img: 
              section === "team" ? jacky:
              shield,
            title: 
              section === "team" ? "Dr. Jacky Anthony So":
              "Excellence", 
            caption: 
              section === "team" ? "Known for his precision and steady hands, Dr. Jacky specializes in preventive care and oral surgery. His commitment to pain-free procedures ensures that every treatment is both effective and stress-free. " :
              section === "story" ? "Our clinic is equipped with modern technology and maintained to the highest standards of cleanliness and safety. You’ll be cared for by professionals who take pride in delivering a top-tier service with precision and compassion." :
              "The facility is clean and up to date. The staff are polite and professional. Doc Jacky's hands were steady while cleaning, so the experience was pain free. I recommend VSDiamond. Thank you!",
            author: 
              section === "testimonials" ? "Rainier Su" :
              null 
          },
          ...(section !== "team"
             ? [{ 
            img: ribbon,
            title: "Expertise", 
            caption: section === "story" ? "Our dentists bring years of experience and a passion for continuous learning. Whether it’s a routine cleaning or a complex procedure, you’ll benefit from skilled hands, thoughtful guidance, and a commitment to lasting results." :
            "Very friendly and super approachable staff. Very flexible rates. It's always great to invest your teeth in people you can trust. Helping me have a great smile boosts my confidence every day.", 
            author: 
              section === "testimonials" ? "Dr. Eugene" :
              null 
          }]
          : []),
          ...(section !== "testimonials" && section !== "team"
            ? [{
              img: clock,
              title: "Reliability", 
              caption: "We value your time and trust. That’s why we offer flexible scheduling, transparent communication, and dependable care you can count on. At VSDiamond, consistency and integrity are part of every smile we help create.",
            }]
          : [])
        ].map((content) => (
                
          <Grid 
            size={{
              xs: 
                section === "team" ? 12 : 
                12,
              sm: 
                section === "team" ? 12 : 
                12,
              md: 
                section === "story" ? 6 : 
                section === "testimonials" ? 12 : 
                section === "team" ? 6 : 
                12,
              lg: 
                section === "story" ? 6 : 
                section === "testimonials" ? 4 : 
                section === "team" ? 6 : 
                4,
              xl: 
                section === "story" ? 3 : 
                section === "testimonials" ? 4 : 
                section === "team" ? 4 : 
                4
            }} 
            item
          >

            <Box
              sx={boxStylesContainer}
            >

              <Card
                elevation={0}
                sx={cardStyleContainer}
              >

                {section !== "testimonials" ? (
                  <Icon
                    src={content.img}
                    size=
                      {section === "team" ? "profilePics" : 
                        "large"}/>
                ) : (
                  <Stack
                    spacing={1}
                    sx={stackStylesRating}
                  >

                      <Rating
                        value={5}
                        readOnly/>

                  </Stack>
                )}
                    
                <CardContent>

                  <Stack
                    direction="column"
                    spacing={2}>

                    {section !== "testimonials" ? (
                      <>
                        <Text
                          text={content.title}
                          variant="h3"/>

                        <Text
                          text={content.caption}
                          variant="body1"/>
                      </>
                    ) : (
                      <>
                        <Text
                          text={content.caption}
                          variant="body1"/>

                        <Text
                          text={content.author}
                          variant="testimonialsH3"/>

                      </>
                    )}
                            

                  </Stack>

                </CardContent>
                            
              </Card>
            
            </Box>

          </Grid>

        ))}

      </Grid>
    </>
  )

}

export default Section;